import { Resolver } from 'react-hook-form';
import { z, ZodIssue, ZodType } from 'zod';

export const phoneString = (requiredMessage?: string) =>
  z.string({ required_error: requiredMessage }).refine(
    (value) => {
      const digits = (value || '').replace(/\D/g, '');
      return digits.length === 10;
    },
    { message: 'Phone number must be 10 digits' },
  );

export const optionalPhoneString = () =>
  z
    .string()
    .optional()
    .refine(
      (value) => {
        if (!value) return true;
        const digits = value.replace(/\D/g, '');
        return digits.length === 10;
      },
      { message: 'Phone number must be 10 digits' },
    );

export const currencyAmountSchema = z.object({
  display: z.string(),
  value: z.number().int().positive('Amount is required'),
});

export const zodResolver =
  <T extends ZodType<any, any, any>>(schema: T): Resolver<z.infer<T>> =>
  async (values) => {
    const result = schema.safeParse(values);
    if (result.success) {
      return { values: result.data, errors: {} };
    }
    const errors: Record<string, { type: string; message: string }> = {};
    for (const issue of result.error.issues as ZodIssue[]) {
      const path = issue.path.map((p) => String(p)).join('.');
      if (!errors[path]) {
        errors[path] = { type: issue.code, message: issue.message };
      }
    }
    return { values: {}, errors: errors as any };
  };
